import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ProductDetailsCart } from '@models';
import { SkeletonTemplateService } from '@skeleton-loader';
import { ConfigurationService, UserService } from '@core';
import { DigitsGroupingPipe } from './../pipes/digits-grouping.pipe';
import { CartOldPriceComponent } from '../cart-old-price/cart-old-price.component';

@Component({
  selector: 'lib-cart-total-info',
  imports: [CommonModule, DigitsGroupingPipe, CartOldPriceComponent],
  templateUrl: './cart-total-info.component.html',
  styleUrl: './cart-total-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartTotalInfoComponent {
  protected readonly rewardName = inject(ConfigurationService).rewardName;
  data = input<ProductDetailsCart | null>();
  totalLabel = input<string>('Total');
  role = input<string>();
  ariaLive = input<string>();

  skeletonService = inject(SkeletonTemplateService);
  readonly canRedeemPoints = inject(UserService).canRedeemPoints;

  // Prices already include tax (US-02.2), so the totals are the subtotals.
  readonly totalPoints = computed(() => Math.floor(this.data()?.subtotalPoints));

  readonly totalPrice = computed(() => this.data()!.subtotalPrice);

  readonly totalDiscountedPrice = computed(() => this.data()!.subtotalDiscountedPrice);
}
